<template>
    <div class="py-4 container-fluid">
        <button class="btn btn-sm tnkc-secondary mb-2 text-white float-right" @click="goBack">
            <font-awesome-icon icon="undo"/>
            Go Back
        </button>

        <!-- Edit modal -->
        <button v-if="isSystemAdmin"
                type="button"
                class="btn btn-sm btn-warning mb-2 float-right mr-3"
                data-backdrop="static"
                data-keyboard="false"
                data-toggle="modal"
                data-target="#edit-crew-modal">
            Edit
        </button>

        <table class="table table-borderless table-sm text-left" id="crewSummary">
            <tbody>
            <tr>
                <td class="bg-light p-3" rowspan="6" style="width: 200px; box-sizing: border-box;">
                    <img :src="tnkcBanner" alt="" style="width: 100%; height: auto;">
                </td>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    APPLICANT No.
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td>{{ crew.applicantNo }}</td>
            </tr>
            <tr>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    NAME
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td>{{ crew.fullName }}</td>
            </tr>
            <tr>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    RANK
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td>{{ crew.rank_Attr }}</td>
            </tr>
            <tr>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    CONTACT No.
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td>20939-1487639, 09066976210</td>
            </tr>
            <tr>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    ADDRESS
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td>{{ crew.address }}</td>
            </tr>
            <!--<tr>
                <td class="px-3" style="width: 150px; font-weight: bold;">
                    SPOUSE NAME
                </td>
                <td style="width: 30px; font-weight: bold;">:</td>
                <td> BOMPAT, AIDA BULAYO</td>
            </tr>-->
            </tbody>
        </table>
        <ul class="nav nav-tabs" id="guestCrew" role="tablist">
            <!-- <li class="nav-item" role="presentation">
                 <a class="nav-link font-weight-bold active"
                    id="experienceNav"
                    data-toggle="tab"
                    href="#experience"
                    role="tab"
                    aria-controls="experience"
                    aria-selected="true">
                     Experience
                 </a>
             </li> -->

            <li class="nav-item" role="presentation">
                <a class="nav-link font-weight-bold active"
                   id="trainingNav"
                   data-toggle="tab"
                   href="#training"
                   role="tab"
                   aria-controls="training"
                   aria-selected="true">
                    Trainings
                </a>
            </li>

            <li class="nav-item" role="presentation">
                <a class="nav-link font-weight-bold"
                   id="roomNav"
                   data-toggle="tab"
                   href="#room"
                   role="tab"
                   aria-controls="room"
                   aria-selected="false" v-show="crew.is_approved === true">
                    Room
                </a>
            </li>

            <li class="nav-item" role="presentation">
                <a class="nav-link font-weight-bold"
                   id="pcrNav"
                   data-toggle="tab"
                   href="#pcrCert"
                   role="tab"
                   aria-controls="pcrCert"
                   aria-selected="false">
                    PCR Cert
                </a>
            </li>

            <!-- todo crew Bookings history tab -->

        </ul>
        <div class="tab-content border-top-0 border-left border-right border-bottom" id="guestCrewTabContent">
            <!-- crew training , -->
            <div class="tab-pane fade show p-2 text-center active" id="training" role="tabpanel"
                 aria-labelledby="trainingNav">
                <h4 class="h4 text-left font-weight-bold">Trainings</h4>
                <div class="table-responsive-sm">
                    <table class="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Training Name</th>
                            <th scope="col">Ranks</th>
                            <th scope="col">Venue</th>
                            <th scope="col">Status</th>
                            <th scope="col">Date From</th>
                            <th scope="col">Date To</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(training, index) in trainings" v-bind:class="trainingSpecification(training)">
                            <th scope="row">{{ index + 1 }}</th>
                            <td class="text-uppercase text-left">
                                <font-awesome-icon class="tnkc-danger-text" v-if="training.trainingScheduleId"
                                                   icon="exclamation"/>
                                {{ training.courseName }}
                            </td>
                            <td>{{ crew.rank_Attr }}</td>
                            <td>{{ training.venue ? training.venue : '' }}</td>
                            <td>{{ evaluateTrainingStatus(training) }}</td>
                            <td>{{ training.dateFrom | moment('D MMM YYYY') }}</td>
                            <td>{{ training.dateTo | moment('D MMM YYYY') }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="tab-pane fade p-2" id="room" role="tabpanel" aria-labelledby="roomNav">
                <h5 class="h5 text-center">Room Reservation
                    <button class="btn btn-link btn-sm font-weight-bold px-0"
                            @click="viewReservationForm(crew.reservation_id)">
                        FORM
                    </button>
                </h5>
                <table class="table table-borderless table-sm w-auto mx-auto">
                    <tbody>
                    <tr class="border-bottom">
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Name
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.fullName }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Room
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.floor ? 'Floor ' + crew.floor + ' —>' : '' }}
                            {{ crew.floor ? 'Room ' + crew.room + ' —>' : '' }}
                            {{ crew.floor ? 'Bed ' + crew.bed : '' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Endorsed Check In
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.endorsed_check_in | moment('D MMM YYYY') }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Endorsed Check Out
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.endorsed_check_out | moment('D MMM YYYY') }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Booked Check In
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.booked_check_in  | moment('D MMM YYYY') }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Booked Check Out
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.booked_check_out | moment('D MMM YYYY') }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Actual Check In
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.actual_check_in  | moment('D MMM YYYY HH:mm') }}</td>
                    </tr>
                    <tr>
                        <td class="px-3 text-left" style="width: 170px; font-weight: bold;">
                            Actual Check Out
                        </td>
                        <td style="width: 30px; font-weight: bold;">:</td>
                        <td>{{ crew.actual_check_out | moment('D MMM YYYY HH:mm') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="tab-pane fade p-2 text-left" id="pcrCert" role="tabpanel" aria-labelledby="pcrNav">
                <!--  todo get the pcr cert of the crew  -->
                <button class="btn tnkc-primary mb-2" data-toggle="modal" data-target="#pcr_upload">
                    <font-awesome-icon icon="plus"/>
                    Add
                </button>
                <div class="table-responsive text-center">
                    <table class="table table-bordered table-sm">
                        <thead>
                        <tr>
                            <th scope="col" class="p-1">#</th>
                            <th scope="col" class="p-1">Swab Date</th>
                            <th scope="col" class="p-1">Result Date</th>
                            <th scope="col" class="p-1">Day(s) From Swab</th>
                            <th scope="col" class="p-1">Uploaded By</th>
                            <th scope="col" class="p-1">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(pcr, index) in pcrs" v-bind:class="checkExpiredPCR(pcr)">
                            <th scope="row" class="align-middle">{{ index + 1 }}</th>
                            <td class="align-middle">{{ pcr.pcr_swab_date | moment('D MMM YYYY') }}</td>
                            <td class="align-middle">{{ pcr.pcr_result_date | moment('D MMM YYYY') }}</td>
                            <td class="align-middle action-col-w">{{ pcr.days_from_swab }}</td>
                            <td class="align-middle">{{ pcr.created_by }}</td>
                            <td class="align-middle action-col-w">
                                <button class="btn btn-sm tnkc-primary" @click="viewPCR(pcr.pcr_id)">
                                    <font-awesome-icon icon="eye"/>
                                    View
                                </button>
                                <!-- todo edit pcr -->
                                <button class="btn btn-sm tnkc-warning mx-2" data-toggle="modal" data-target="#pcr_edit"
                                        @click="editPCR(pcr.pcr_id)">
                                    <font-awesome-icon icon="edit"/>
                                    Edit
                                </button>
                                <button class="btn btn-sm tnkc-danger" @click="deletePCR(pcr.pcr_id)">
                                    <font-awesome-icon icon="trash"/>
                                    Delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <PCR_upload :crew_id=parseInt(this.id)></PCR_upload>

        <div class="modal fade" id="pcr_edit" tabindex="-1" role="dialog" aria-labelledby="pcr_edit_title"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <form @submit.prevent="" enctype="multipart/form-data">
                        <div class="modal-header">
                            <h5 class="modal-title font-weight-bold" id="pcr_edit_title">Edit PCR Certificate</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body text-left">
                            <div class="form-group">
                                <label class="mb-0" for="edit_pcr_file">
                                    <span class="tnkc-danger-text">*</span>
                                    Replace PCR Certificate:
                                </label>
                                <input type="file" class="form-control p-1" id="edit_pcr_file">
                            </div>
                            <div class="form-group">
                                <label class="mb-0" for="edit_pcr_swab_date">
                                    <span class="tnkc-danger-text">*</span>
                                    Swab Date:
                                </label>
                                <input class="form-control" id="edit_pcr_swab_date" type="date" required
                                       :value="pcrDetails.pcr_swab_date">
                            </div>
                            <div class="form-group">
                                <label class="mb-0" for="edit_pcr_result_date">
                                    <span class="tnkc-danger-text">*</span>
                                    Result Date:
                                </label>
                                <input class="form-control" id="edit_pcr_result_date" type="date" required
                                       :value="pcrDetails.pcr_result_date">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">
                                <font-awesome-icon icon="times"/>
                                Cancel
                            </button>
                            <button type="submit" class="btn tnkc-primary" @click="updatePCR(pcrDetails.id)">
                                <font-awesome-icon icon="file-upload"/>
                                Upload
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="edit-crew-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Crew Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-left">
                        <form>
                            <!-- Full name -->
                            <div class="form-group">
                                <label for="full-name">Full Name :</label>
                                <input type="text"
                                       class="form-control form-control-plaintext text-left align-middle"
                                       id="full-name"
                                       placeholder="Full Name"
                                       disabled
                                       :value="crew.fullName">
                            </div>

                            <!-- Rank -->
                            <div class="form-group">
                                <label for="rank">Rank :</label>
                                <select name="RankSelection" id="rank-selection"
                                        :disabled="!isEditable"
                                        v-model="crew.rank_id"
                                        :class="{'form-control form-control-plaintext' : !isEditable,'form-control form-control' : isEditable}">
                                    <option :value="null" class="text-center align-middle">-- select --</option>
                                    <option  class="text-center align-middle" v-for="(rank,index) in objRanks"
                                             :selected="crew.rank_id === rank.id"
                                            :value="rank.id"
                                             @click="setCrewRank"
                                            :key="rank.id">
                                        <span>{{ rankNamespace(rank) }}</span>
                                    </option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div v-if="!isEditable">
                            <button type="button" class="btn btn-warning" @click="edit(crew)">Edit</button>
                            <button type="button" class="btn btn-secondary ml-2" @click="closeEdit()">Close</button>
                        </div>
                        <div v-else>
                            <button type="button" class="btn btn-success" @click="saveEdit()">Save</button>
                            <button type="button" class="btn btn-danger ml-2" @click="cancelEdit()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TnkcBanner from '../../assets/tnkc-banner.png'
import { appMixins } from '@/mixins/app.mixins'
import { mapGetters, mapActions } from 'vuex'
import PCR_upload from '@/components/crew/_modals/PCR_upload'
import { GlobalUtility } from '@/service/global-utility.service'

export default {
  name: 'CrewProfile',
  props: ['id', 'hotelId'],
  mixins: [appMixins],
  components: {
    PCR_upload
  },
  data () {
    return {
      tnkcBanner: TnkcBanner,
      trainingParams: {
        crewid: this.id, providerId: 1
      },
      isEditable: false,
      crewDetailsForm: {}
    }
  },

  methods: {
    ...mapActions([
      'getCrewTrainingDetails',
      'getCrewDetail',
      'getCrewPCRS',
      'getPCRFile',
      'setCrewNull',
      'deletePCRFile',
      'getPCRDetails',
      'updateCov19MedCert',
      'updateCrewRank'
    ]),

    trainingSpecification (obj) {
      if (obj.trainingcompleted) {
        return 'complete'
      }

      if (obj.isMandatory && !obj.trainingCompleted) {
        return 'isMandatory'
      }

      if (!obj.isValid) {
        return 'bg-expired'
      }
    },

    evaluateTrainingStatus (obj) {
      if (obj.cancelledAt) {
        return 'CANCELLED'
      }

      if (obj.wasConducted && !obj.trainingCompleted) {
        return 'INCOMPLETE'
      } else if (!obj.wasConducted) {
        const dateFrom = new Date(obj.dateFrom)
        const dateTo = new Date(obj.dateTo)
        const dateNow = new Date()

        if (dateFrom > dateNow) {
          return 'PENDING'
        } else if (dateFrom >= dateNow && dateNow <= dateTo) {
          return 'ON GOING'
        } else {
          return '---'
        }
      } else if (!obj.isValid) {
        return 'EXPIRED'
      } else if (obj.trainingCompleted && obj.wasConducted) {
        return 'COMPLETED'
      } else {
        return 'INCOMPLETE'
      }
    },

    // todo convert base64 string to blob then display as pdf
    viewPCR (pcrid) {
      this.getPCRFile({ pcr_id: pcrid }).then((res) => {
        if (res == true) {
          this.viewPdfFile(this.pcrFile)
        }
      })
    },
    viewReservationForm (reservation_id) {
      this.$router.push({ name: 'CrewRsrvForm', params: { id: reservation_id } })
    },

    async deletePCR (pcrid) {
      if (await this.questionAlert('Are you sure you want to delete this PCR certificate', 'DELETE')) {
        this.deletePCRFile(pcrid).then((res) => {
          if (res == true) {
            this.successAlert('Deleted Successfully', 'Delete')
            this.getCrewPCRS(this.id)
          }
        })
      }
    },

    async editPCR (pcrid) {
      this.getPCRDetails(pcrid).then((res) => {
        if (res == true) {
          return this.pcrDetails
        }
      })
    },

    async updatePCR (pcrid) {
      if (await this.questionAlert('Are you sure you want to save your changes.', 'UPDATE')) {
        const file = document.getElementById('edit_pcr_file').files[0]
        this.pcr_swab_date = document.getElementById('edit_pcr_swab_date').value
        this.pcr_result_date = document.getElementById('edit_pcr_result_date').value
        const formData = new FormData()
        formData.append('pcr_id', pcrid)
        formData.append('pcr_swab_date', this.pcr_swab_date)
        formData.append('pcr_result_date', this.pcr_result_date)
        formData.append('crew_id', this.id)
        if (file) {
          formData.append('file', file)
        }
        this.updateCov19MedCert(formData).then((response) => {
          if (response == true) {
            this.successAlert('Update Successfully', 'Update')
            $('#pcr_edit').modal('hide')
            this.getCrewPCRS(this.id)
          }
        }).catch((error) => {})
      }
    },

    checkExpiredPCR (obj) {
      if (obj.days_from_swab < 0) {
        return 'bg-expired'
      }
    },

    cancelEdit () {
      Object.assign(this.crew, this.crewDetailsForm)
      this.isEditable = false
      console.log('Ticking cancel . . .', this.crewDetailsForm)
    },

    edit (value) {
      Object.assign(this.crewDetailsForm, value)
      this.isEditable = true
    },

    async saveEdit () {
      if (await this.questionAlert('Are you sure you want to save your changes.', 'UPDATE')) {
        await this.updateCrewRank(this.crew).then((r) => {
          if (r == true) {
            this.$nextTick(() => {
              this.getCrewDetail(this.id)
              this.isEditable = false
            })
          }
        })
      }
    },

    // close
    closeEdit () {
      $('#edit-crew-modal').modal('hide')
      this.crewDetailsForm = {}
    },

    rankNamespace ({ name, alias }) {
      let rankDetails
      rankDetails = `[ ${alias.toUpperCase()} ]  - ${name.toUpperCase()}`
      return rankDetails
    },
    setCrewRank (id) {
      this.crew.rank_id = id
    }
  },

  computed: {
    ...mapGetters([
      'trainings', 'crew', 'pcrs', 'pcrFile', 'pcrDetails',
      'objRanks'
    ])

  },
  created () {
    this.getCrewTrainingDetails(this.trainingParams)
    this.getCrewDetail(this.id)
    this.getCrewPCRS(this.id)
  },
  mounted () {},
  destroyed () {
    this.setCrewNull()
  }
}
</script>

<style scoped>
#guestCrew .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    background-color: #b3dcfa;
}

</style>
<style>
.isMandatory {
    background: #d3ebfc !important;
}

.text-isMandatory {
    color: #d3ebfc !important;
}

.complete {
    background: #32e7c4 !important;
}

.bg-expired {
    background-color: #ffc8bd;
}

.action-col-w {
    width: 240px;
}
</style>
